const routers = [
    {
        path: '/personal_center/enterprise',
        name: 'park_payment',
        meta: {
            exp: '企业服务',
            requireAuth: true
        },
        redirect:"/personal_center/enterprise/enterprise_info",
        component: () => import('@/views/personal_center/enterprise/index.vue'),
        children: [
            {
                path:'/personal_center/enterprise/enterprise_info',
                name:'enterprise_info',
                meta:{
                    exp:'园区信息',
                    requireAuth: true
                },
                component: () => import('@/views/personal_center/enterprise/user_info/index.vue'),

            },
            {
                path: '/personal_center/enterprise/park_payment',
                name: 'park_payment',
                meta: {
                    exp: '园区缴费',
                    requireAuth: true
                },
                component: () => import('@/views/personal_center/enterprise/park_payment/index.vue'),
            },
            {
                path: '/personal_center/enterprise/overtime_application',
                name: 'overtime_application',
                meta: {
                    exp: '加班申请',
                    requireAuth: true
                },
                component: () => import('@/views/personal_center/enterprise/overtime_application/index.vue'),
                redirect: '/personal_center/enterprise/overtime_application/overtime_record',
                children: [
                    {
                        path: '/personal_center/enterprise/overtime_application/overtime_record',
                        name: 'overtime_record',
                        meta: {
                            exp: '申请记录',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/overtime_application/overtime_record/index.vue')
                    },
                    {
                        path: '/personal_center/enterprise/overtime_application/overtime_apply',
                        name: 'overtime_apply',
                        meta: {
                            exp: '申请加班',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/overtime_application/overtime_apply/index.vue')
                    }
                ]
            },
            {
               path: '/personal_center/enterprise/booking_room',
               name: 'booking_room',
               meta: {
                  exp: '预约看房',
                  requireAuth: true
               },
               redirect: '/personal_center/enterprise/booking_room/booking_room_record',
               component: () => import('@/views/personal_center/enterprise/booking_room/index.vue'),
               children:[
                    {
                        path: '/personal_center/enterprise/booking_room/booking_room_record',
                        name: 'booking_room_record',
                        meta: {
                            exp: '我的预定',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/booking_room/booking_room_record/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/booking_room/booking_room_detail',
                        name: 'booking_room_record',
                        meta: {
                            exp: '查看详情',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/booking_room/booking_room_detail/index.vue'),
                    }
               ]
            },  
            {
                path: '/personal_center/enterprise/enterprise_certification',
                name: 'enterprise_certification',
                meta: {
                    exp: '企业认证',
                    requireAuth: true
                },
                redirect: '/personal_center/enterprise/enterprise_certification/enterprise_certificaiton_table_list',
                component: () => import('@/views/personal_center/enterprise/enterprise_certification/index.vue'),
                children: [
                    {
                        path: '/personal_center/enterprise/enterprise_certification/enterprise_certificaiton_table_list',
                        name: 'enterprise_certificaiton_table_list',
                        meta: {
                            exp: '企业认证列表',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/enterprise_certification/certificaiton_table_list/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/enterprise_certification/enterprise_certification_from',
                        name: 'enterprise_certification_from',
                        meta: {
                            exp: '企业认证表单',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/enterprise_certification/certification_from/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/enterprise_certification/enterprise_certification_details',
                        name: 'enterprise_certification_details',
                        meta: {
                            exp: '企业认证详情',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/enterprise_certification/certification_details/index.vue'),
                    },
                ]
            },
            {
                path: '/personal_center/enterprise/staff_management',
                name: 'staff_management',
                meta: {
                    exp: '员工管理',
                    requireAuth: true
                },
                redirect: '/personal_center/enterprise/staff_management/staff_manegement_record',
                component: () => import('@/views/personal_center/enterprise/staff_management/index.vue'),
                children: [
                    {
                        path: '/personal_center/enterprise/staff_management/staff_manegement_record',
                        name: 'staff_management_record',
                        meta: {
                            exp: '员工管理',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/staff_management/staff_management_record/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/staff_management/staff_manegement_detail',
                        name: 'staff_management_detail',
                        meta: {
                            exp: '查看详情',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/staff_management/staff_management_detail/index.vue'),
                    }
                ]
            },
            {
                path: '/personal_center/enterprise/admission_to_the_park',
                name: 'admission_to_the_park',
                meta: {
                    exp: '入驻园区',
                    requireAuth: true
                },
                redirect: '/personal_center/enterprise/admission_to_the_park/admission_to_the_park_certificaiton_table_list',
                component: () => import('@/views/personal_center/enterprise/admission_to_the_park/index.vue'),
                children: [
                    {
                        path: '/personal_center/enterprise/admission_to_the_park/admission_to_the_park_certificaiton_table_list',
                        name: 'admission_to_the_park_table_list',
                        meta: {
                            exp: '园区入驻申请列表',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/admission_to_the_park/certificaiton_table_list/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/admission_to_the_park/admission_to_the_park_from',
                        name: 'admission_to_the_park_from',
                        meta: {
                            exp: '园区入驻申请表单',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/admission_to_the_park/certification_from/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/admission_to_the_park/admission_to_the_park_certification_details',
                        name: 'admission_to_the_park_details',
                        meta: {
                            exp: '园区入驻申请详情',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/admission_to_the_park/certification_details/index.vue'),
                    },
                ]
            },
            {
                path: '/personal_center/enterprise/contract',
                name: 'enterprise_contract',
                meta: {
                    exp: '我的合同',
                    requireAuth: true
                },
                redirect: '/personal_center/enterprise/contract/table_list',
                component: () => import('@/views/personal_center/enterprise/contract/index.vue'),
                children: [
                    {
                        path: '/personal_center/enterprise/contract/table_list',
                        name: 'enterprise_contract_table_list',
                        meta: {
                            exp: '我的合同列表',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/contract/table_list/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/contract/download',
                        name: 'enterprise_contract_download',
                        meta: {
                            exp: '合同模板',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/contract/table_list/download.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/contract/details',
                        name: 'enterprise_contract_details',
                        meta: {
                            exp: '我的合同详情',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/contract/details/index.vue'),
                    },
                ]
            },
            {
                path: '/personal_center/enterprise/statistical',
                name: 'enterprise_statistical',
                meta: {
                    exp: '统计汇报',
                    requireAuth: true
                },
                redirect: '/personal_center/enterprise/statistical/table_list',
                component: () => import('@/views/personal_center/enterprise/statistical/index.vue'),
                children: [
                    {
                        path: '/personal_center/enterprise/statistical/table_list',
                        name: 'enterprise_statistical_table_list',
                        meta: {
                            exp: '统计汇报列表',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/statistical/table_list/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/statistical/from',
                        name: 'enterprise_statistical_from',
                        meta: {
                            exp: '统计汇报表单(季度统计)',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/statistical/from/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/statistical/enterprise_statistical_enterprise_from',
                        name: 'enterprise_statistical_enterprise_from',
                        meta: {
                            exp: '统计汇报表单(在孵企业情况)',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/statistical/from/enterprise.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/statistical/details',
                        name: 'enterprise_statistical_details',
                        meta: {
                            exp: '统计汇报详情',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/statistical/details/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/statistical/enterprise_details',
                        name: 'enterprise_statistical_enterprise_details',
                        meta: {
                            exp: '统计汇报详情(在孵企业情况)',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/statistical/details/enterprise.vue'),
                    },
                ]
            },
            {
                path: '/personal_center/enterprise/property_services',
                name: 'enterprise_property_services',
                meta: {
                    exp: '物业服务',
                    requireAuth: true
                },
                redirect: '/personal_center/enterprise/property_services/pass/table_list',
                component: () => import('@/views/personal_center/enterprise/property_services/index.vue'),
                children: [
                    {
                        path: '/personal_center/enterprise/property_services/pass/table_list',
                        name: 'enterprise_pass_table_list',
                        meta: {
                            exp: '物品放行',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/property_services/pass/table_list/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/property_services/pass/form',
                        name: 'enterprise_pass_form',
                        meta: {
                            exp: '物品放行表单',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/property_services/pass/from/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/property_services/pass/detail',
                        name: 'enterprise_pass_detail',
                        meta: {
                            exp: '物品放行详情',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/property_services/pass/details/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/property_services/pass/process',
                        name: 'enterprise_pass_process',
                        meta: {
                            exp: '物品放行流程',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/property_services/pass/process/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/property_services/renovation/table_list',
                        name: 'enterprise_renovation_table_list',
                        meta: {
                            exp: '装修申请',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/property_services/renovation/table_list/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/property_services/renovation/form',
                        name: 'enterprise_renovation_form',
                        meta: {
                            exp: '装修申请表单',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/property_services/renovation/from/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/property_services/renovation/detail',
                        name: 'enterprise_renovation_detail',
                        meta: {
                            exp: '装修申请详情',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/property_services/renovation/details/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/property_services/renovation/process',
                        name: 'enterprise_renovation_process',
                        meta: {
                            exp: '装修申请流程',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/property_services/renovation/process/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/property_services/air_conditioner/table_list',
                        name: 'enterprise_air_conditioner_table_list',
                        meta: {
                            exp: '安装空调',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/property_services/air_conditioner/table_list/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/property_services/air_conditioner/form',
                        name: 'enterprise_air_conditioner_form',
                        meta: {
                            exp: '安装空调表单',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/property_services/air_conditioner/from/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/property_services/air_conditioner/detail',
                        name: 'enterprise_air_conditioner_detail',
                        meta: {
                            exp: '安装空调详情',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/property_services/air_conditioner/details/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/property_services/air_conditioner/process',
                        name: 'enterprise_air_conditioner_process',
                        meta: {
                            exp: '安装空调申请流程',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/property_services/air_conditioner/process/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/property_services/evacuate/table_list',
                        name: 'enterprise_evacuate_table_list',
                        meta: {
                            exp: '入驻撤离申请',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/property_services/evacuate/table_list/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/property_services/evacuate/form',
                        name: 'enterprise_evacuate_form',
                        meta: {
                            exp: '入驻撤离申请表单',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/property_services/evacuate/from/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/property_services/evacuate/detail',
                        name: 'enterprise_evacuate_detail',
                        meta: {
                            exp: '入驻撤离申请详情',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/property_services/evacuate/details/index.vue'),
                    },
                    {
                        path: '/personal_center/enterprise/property_services/evacuate/process',
                        name: 'enterprise_evacuate_process',
                        meta: {
                            exp: '入驻撤离申请流程',
                            requireAuth: true
                        },
                        component: () => import('@/views/personal_center/enterprise/property_services/evacuate/process/index.vue'),
                    },
                ]
            },
        ]
    },

]
export default routers